import { FreeDataValueWrapper, FreeDataValueCriteria, FreeDataValueScenario } from '@wizeoo/akm-message-lib';
import { ExternalAPI } from '../../../model/external-api';
import { Model } from '../../../model/model';
import { FreedataValueVO } from  '../../../vo/core/freedatavalue.vo';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';

/**
 * Appels FDV pour contrôle d'unicité
 * Author LMA
 */
export class FreeDataValueUnicityCmd extends WizCommand<FreeDataValueWrapper> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  } 

  public fdv: FreedataValueVO = null;

  /** retourne un wrapper pre-alimenté */
  public freedataValueWrapper(): FreeDataValueWrapper {
    const wrapper: FreeDataValueWrapper = new FreeDataValueWrapper();
    wrapper.criteria = new FreeDataValueCriteria();
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    wrapper.scenario = new FreeDataValueScenario();
    wrapper.scenario.languageCode = this.model.localeEngine.getLocale();
    return wrapper;
  }

  /** 
   * collecte des FD modifiés / créés sur base NumRev
   * 
   * @param freedataValue le clone en cours de création
   * @param callback de retour
   * @returns la commande préparée
   */
   public checkUnicity(fdv : FreedataValueVO, callback?: Function): FreeDataValueUnicityCmd {
    this.fdv = fdv;
    const wrapper: FreeDataValueWrapper = this.freedataValueWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    wrapper.criteria.codeOrShort = fdv.code;
    wrapper.criteria.freeDataCode = fdv.freeDataCode;
    this.configureRemote(ExternalAPI.FREEDATA_VALUE_API, wrapper, callback);
    return this;
  }


  /** sur retour, traitement selon la méthode */
  public wizResult() {
    super.wizResult();
    if (this.result) {
      // console.log('result', 'prb si > 0');
    } else {
      // console.log('freedataValueCmd no result');
    }
  }

}
